import { render } from "./quotemensajes_ingles.vue?vue&type=template&id=3b2bc37c&scoped=true"
import script from "./quotemensajes_ingles.vue?vue&type=script&lang=js"
export * from "./quotemensajes_ingles.vue?vue&type=script&lang=js"

import "./quotemensajes_ingles.vue?vue&type=style&index=0&id=3b2bc37c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2bc37c"]])

export default __exports__